import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import AccessDeniedPage from './AccessDeniedPage';
import { useRouteAccess } from '../hooks/useRouteAccess';

interface AuthorizedRouteProps {
  children: React.ReactNode;
}

const AuthorizedRoute: React.FC<AuthorizedRouteProps> = ({ children }) => {
  const { decision, denyMessage, pathname } = useRouteAccess();

  if (decision === 'pending') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (decision === 'deny') {
    return <AccessDeniedPage message={denyMessage} requestedPath={pathname} />;
  }

  return <>{children}</>;
};

export default AuthorizedRoute;
